import { authAPI } from '../api/auth';

export const isAdmin = () => authAPI.isAuthenticated();

export const requireAuth = () => {
  if (!isAdmin()) {
    window.location.href = '/admin/login';
    return false;
  }
  return true;
};

export const getAdminData = () => {
  const data = localStorage.getItem('adminData');
  return data ? JSON.parse(data) : null;
};